<template>
  <div>
    <el-carousel
      :autoplay="autoplay"
      :initial-index="initialIndex"
      @change="onChange"
      class="my-carousel"
      ref="carousel"
      :height="carouselHeight + 'px'"
      indicator-position="outside"
    >
      <el-carousel-item v-for="(item, index) in sliders" :key="index">
        <!-- <vue3VideoPlay
          v-if="item.imgUrl.indexOf('mp4') !== -1"
          ref="videoPlayer"
          v-bind="options"
          :height="computeHeight"
          @play="onPlayerPlay($event)"
          @ended="onPlayerEnded($event)"
        />
        <img v-else :src="item.imgUrl" class="slider_img" /> -->

        <img
          :ref="'image_' + index"
          @load="onImageLoad(index)"
          :src="item.imgUrl"
          class="slider_img"
        />
        <!-- <h3>{{ item.createTime }}</h3> -->
        <!-- <img :src="sliders[0].src" style="width:100%;opacity: 0;" class="slider_img" alt=""> -->
      </el-carousel-item>
    </el-carousel>
    <div class="wrapper">
      <div class="wrap1">
        <div id="" class="solve head-label">
          <div style="text-align: center" class="font_size_24">我们的优势</div>
          <div class="head-hen" style="text-align: center"></div>
          <div class="font_size_24_yin" style="text-align: center">
            COMPANY PROFILE
          </div>
        </div>
        <!-- 盒子 -->
        <div class="border_parent">
          <el-row :gutter="10">
            <el-col
              :xs="12"
              :sm="12"
              :md="6"
              v-for="(item, index) in productSolutionsImages"
              :key="index"
            >
              <div class="border">
                <div class="border_img_parent">
                  <img :src="item.img" class="img_border" />
                </div>
                <div class="border_title">
                  {{ item.title }}
                </div>
                <div class="border_content_one">
                  {{ item.content }}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="wrap2" id="公司介绍">
        <div class="introduce" v-if="seen">
          <div class="introduce-let">
            <img src="../../static/other/company_img@2x.png" alt="" />
          </div>
          <div class="introduce-ret">
            <div class="introduce-ret-head">
              <div class="font_size_24">公司简介</div>
              <div class="font_size_24_yin">COMPANY PROFILE</div>
              <div class="head-hen"></div>
            </div>
            <div class="introduce-ret-content">
              <p>
                深圳水母物联安全技术有限公司专注于家庭安全领域，致力于通过软件科技的力量为家庭提供全方位的安全保障。我们的核心产品包括水母物联小程序、APP、iOS应用以及Web后台管理系统，这些工具共同构成了一个综合性的家庭安全服务平台。
              </p>
              <p>
                我们特别推出了安消一体的家庭套餐包，旨在为家庭用户提供一站式的安全解决方案。这个套餐不仅包括了智能消防预警系统，还涵盖了物业、家政、家装以及家庭火灾保险等生活服务，确保家庭安全的同时，也提供了便利的日常生活支持。
              </p>
              <p>
                水母物联安全技术有限公司通过物联网技术，将家庭中的各种安全设备互联互通，实现远程监控和管理。我们的系统能够实时监测家中的烟雾、燃气、水浸、电力等安全状况，一旦发现异常，立即通知用户，让用户能够迅速采取应对措施，防患于未然。
              </p>
              <p>
                我们坚持客户至上的服务理念，以数据为驱动，以平台为依托，为用户提供精准、及时的安全服务。水母物联安全技术有限公司的愿景是让每个家庭都能享受到科技带来的安全与便捷，让安全成为幸福生活的基石。
              </p>
            </div>
          </div>
        </div>
        <div class="introduce-h5" v-if="!seen">
          <div id="" class="solve head-label">
            <div style="text-align: center" class="font_size_24">公司简介</div>
            <div class="head-hen" style="text-align: center"></div>
            <div class="font_size_24_yin" style="text-align: center">
              COMPANY PROFILE
            </div>
          </div>
          <div class="introduce-let-h5">
            <img src="../../static/other/company_img@2x.png" alt="" />
          </div>
          <div class="introduce-ret-h5">
            <div class="introduce-ret-content-h5">
              <p>
                深圳水母物联安全技术有限公司专注于家庭安全领域，致力于通过软件科技的力量为家庭提供全方位的安全保障。我们的核心产品包括水母物联小程序、APP、iOS应用以及Web后台管理系统，这些工具共同构成了一个综合性的家庭安全服务平台。
              </p>
              <p>
                我们特别推出了安消一体的家庭套餐包，旨在为家庭用户提供一站式的安全解决方案。这个套餐不仅包括了智能消防预警系统，还涵盖了物业、家政、家装以及家庭火灾保险等生活服务，确保家庭安全的同时，也提供了便利的日常生活支持。
              </p>
              <p>
                水母物联安全技术有限公司通过物联网技术，将家庭中的各种安全设备互联互通，实现远程监控和管理。我们的系统能够实时监测家中的烟雾、燃气、水浸、电力等安全状况，一旦发现异常，立即通知用户，让用户能够迅速采取应对措施，防患于未然。
              </p>
              <p>
                我们坚持客户至上的服务理念，以数据为驱动，以平台为依托，为用户提供精准、及时的安全服务。水母物联安全技术有限公司的愿景是让每个家庭都能享受到科技带来的安全与便捷，让安全成为幸福生活的基石。
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="wrap3">
        <div id="产品介绍" class="solve head-label">
          <div style="text-align: center" class="font_size_24">产品介绍</div>
          <div class="head-hen" style="text-align: center"></div>
          <div class="font_size_24_yin" style="text-align: center">
            RELATED PRODUCT INTRODUCTION
          </div>
        </div>
        <div class="wrap3-border">
          <swiper
            :modules="modules"
            :slides-per-view="seen ? 4 : 1"
            :space-between="50"
            :loop="true"
            navigation
            :pagination="{ clickable: true }"
            :autoplay="{
              delay: 2000,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
          >
            <swiper-slide v-for="(item, index) in product" :key="index"
              ><div class="border-slide">
                <div class="border-slide-img">
                  <img :src="item.img" alt="" />
                </div>
                <div class="border-slide-bom">
                  <div class="titer">{{ item.tiele }}</div>
                  <div class="number">{{ item.number }}</div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div> -->
      <!-- <div class="wrap3-Genduo" @click="goProductCenter">更多产品</div> -->
      <div class="wrap4">
        <div id="联系我们" class="solve head-label">
          <div style="text-align: center" class="font_size_24">联系我们</div>
          <div class="head-hen" style="text-align: center"></div>
          <div class="font_size_24_yin" style="text-align: center">
            CONTACT US
          </div>
        </div>
        <div class="wrap4-border">
          <div class="li-1">
            <img src="../../static/other/profile_1@2x.png" alt="" />
            <div>王总</div>
            <div>13911299113</div>
          </div>
          <div class="li-2">
            <div class="li-2-zhong">招商</div>
            <div class="li-2-ying">ATTRACT INVESTMENT</div>
          </div>
          <div class="heng"></div>
          <div class="li-3">
            <div class="li-3-zhong">客服</div>
            <div class="li-3-ying">ATTRACT INVESTMENT</div>
          </div>
          <div class="li-1">
            <img src="../../static/other/profile_2@2x.png" alt="" />
            <div>李工</div>
            <div>15323733119</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, ref } from "vue";
// import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, A11y, Autoplay } from "swiper/modules";
// import { getOfficialList } from "@/request/url";
import "swiper/css";
import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "swiper/css/scrollbar";
export default {
  components: {
    // Swiper,
    // SwiperSlide,
  },
  name: "Index",
  setup() {
    let videoPlayer = ref(null);
    return { videoPlayer };
  },
  data() {
    return {
      modules: [Navigation, A11y, Autoplay],
      seen: true,
      autoplay: true, //自动播放
      initialIndex: 0, //从下标第几个开始轮播
      sliders: [],
      carouselHeight: 800, // 假设容器的宽度为600px
      imageRatios: [], // 存储每张图片的宽高比
      productSolutionsImages: [
        {
          img: require("../../static/other/专业@2x.png"),
          title: "专业",
          content: "专注智能设备与系统平台研发、生产、销售于一体的高科技企业。",
        },
        {
          img: require("../../static/other/经验@2x.png"),
          title: "经验",
          content: "10年行业经验，为智慧产品、安全管理提供分类解决方案。",
        },
        {
          img: require("../../static/other/品质@2x.png"),
          title: "品质",
          content: "先后获得国家高新技术企业、中关村高新技术企业、专精特新。",
        },
        {
          img: require("../../static/other/服务@2x.png"),
          title: "服务",
          content:
            "拥有丰富行业经验的商务和技术服务团队，提供客服7*24小时服务。",
        },
      ],
      product: [
        {
          tiele: "SOS紧急呼叫按钮",
          img: require("../../static/other/product-1.png"),
          // number: "WANLIN-307",
          notes: "WANLIN-307",
        },
        {
          tiele: "独立式光电感烟火灾探测报警器",
          img: require("../../static/other/product-2.png"),
          // number: "WANLIN-308",
          notes: "WANLIN-308",
        },
        {
          tiele: "燃气探测器",
          img: require("../../static/other/product-3.png"),
          // number: "WANLIN-309",
          notes: "WANLIN-309",
        },
        {
          tiele: "门磁",
          img: require("../../static/other/product-4.png"),
          // number: "WANLIN-310",
          notes: "WANLIN-310",
        },
        {
          tiele: "门铃",
          img: require("../../static/other/product-5.png"),
          // number: "WANLIN-311",
          notes: "WANLIN-311",
        },
        {
          tiele: "水浸探测器",
          img: require("../../static/other/product-6.png"),
          // number: "WANLIN-312",
          notes: "WANLIN-312",
        },
      ],

      options: reactive({
        width: "100%", //播放器宽度
        //height: "500px", //播放器高度
        color: "#409eff", //主题色
        title: "碧华寻迹小车", //视频名称
        src: require("../../static/video/xiaoche.mp4"), //视频源
        //poster: require("../../static/slider/xiaoche.png"),
        muted: false, //静音
        webFullScreen: false,
        speedRate: ["0.75", "1.0", "1.25", "1.5", "2.0"], //播放倍速
        autoPlay: true, //自动播放
        loop: false, //循环播放
        mirror: false, //镜像画面
        ligthOff: false, //关灯模式
        volume: 0.3, //默认音量大小
        control: true, //是否显示控制
        controlBtns: [
          "audioTrack",
          "quality",
          "speedRate",
          "volume",
          "setting",
          "pip",
          "pageFullScreen",
          "fullScreen",
        ], //显示所有按钮,
      }),
    };
  },

  watch: {},
  methods: {
    // async getList() {
    //   let data = await getOfficialList();
    //   this.sliders = data;
    // },
    goProductCenter() {
      this.$router.push({
        path: `/ProductCenter`,
      });
    },
    onSwiper() {},
    onSlideChange() {},
    // 监听轮播图改变
    onChange() {
      // console.log(index);
      // 如果是视频,就等播放完再进行下一个
      // if (
      //   this.sliders[index].img.indexOf("mp4") != -1 &&
      //   this.options["src"] != this.sliders[index].img
      // ) {
      //   this.options["src"] = this.sliders[index].img; //把获取来的视频赋值给sources的src
      //   this.options["poster"] = this.sliders[index].poster;
      //   this.videoPlayer.src = this.options["src"]; // 重置进度条,再次轮播时让视频重新播放
      //   this.videoPlayer.poster = this.options["poster"];
      //   this.autoplay = false;
      // }
    },
    // onPlayerEnded() {
    //   //视频播放停止时候触发的事件
    //   this.autoplay = true;
    // },
    // onPlayerPlay() {
    //   this.autoplay = false;
    // },

    menuSeen() {
      // 屏幕尺寸
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 430) {
        this.seen = true;
      } else {
        this.seen = false;
      }
    },
    onImageLoad(index) {
      const img = this.$refs["image_" + index][0]; // 注意：$refs 返回的是一个数组或 DOM 元素（取决于你如何设置 ref）
      if (img) {
        const ratio = img.naturalWidth / img.naturalHeight;

        // 根据你的逻辑更新 carouselHeight
        // 例如，假设轮播容器的宽度是固定的（比如 600px）
        const containerWidth = document.body.clientWidth;
        this.carouselHeight = containerWidth / ratio;
      }
    },
    updateCarouselHeight() {
      // 假设我们根据第一张图片的宽高比来设置高度（或者你可以选择其他逻辑）
      if (this.imageRatios.length > 0) {
        const firstRatio = this.imageRatios[0];
        // 假设容器的宽度是固定的，比如600px
        const containerWidth = 600;
        this.carouselHeight = containerWidth / firstRatio; // 根据宽高比计算高度
      }
    },
  },
  mounted() {
    // this.getList();

    // this.updateCarouselHeight();
    // this.sliders = [
    //   {
    //     // poster: require("../../static/slider/xiaoche.png"),
    //     // img: require("../../static/video/xiaoche.mp4"),
    //     img: require("../../static/slider/Carousel-img1.png"),
    //   },
    //   {
    //     img: require("../../static/slider/Carousel-img1.png"),
    //   },
    //   {
    //     img: require("../../static/slider/Carousel-img1.png"),
    //   },
    // ];
    this.menuSeen();
  },
  computed: {
    // //计算高度
    // computeHeight() {
    //   // let screenHeight = document.body.clientWidth;
    //   // if (screenHeight > 430) {
    //   //   return "700px";
    //   // } else {
    //   //   return "185px";
    //   // }
    //    // 假设我们使用第一张图片的宽高比来计算高度
    //    const { width, height } = this.sliders[0].imgUrl;
    //   return (this.carouselWidth * height) / width;
    // },
    computeAdminHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 430) {
        return "450px";
      } else {
        return "200px";
      }
    },
    computePCHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 430) {
        return "500px";
      } else {
        return "200px";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.my-carousel {
}
.el-carousel {
  // .el-carousel__item:nth-child(2n) {
  //   background-color: #99a9bf;
  // }
  // .el-carousel__item:nth-child(2n + 1) {
  //   background-color: #d3dce6;
  // }
  :deep(.el-carousel__indicators--outside) {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0%;
    left: 48%;
  }
  :deep(.el-carousel__indicator) {
    // 指示器
    // left: unset;
    // transform: unset;
    // right: 2%;
    // background: #fff;
    margin-right: 24px;
  }
  :deep(.el-carousel__button) {
    // 指示器按钮
    width: 10px;
    height: 10px;
    border: none;
    border-radius: 50%;
    opacity: none;
    // background-color: rgba(0, 0, 0, 0.2);
    background-color: #fff;
  }
  :deep(.is-active .el-carousel__button) {
    // 指示器激活按钮
    background: #3575fb;
  }

  // :deep(.el-carousel__container) {
  //  height: 100%;
  // }
}

.border_parent {
  // width: 90%;
  margin: auto;
}

.slider_img {
  // height: 100%;
  // width: 100%;

  // height: auto;
  // width: auto;
  // max-height: 100%;
  // max-width: 100%;

  width: 100%; /* 图片宽度适应容器 */
  height: auto; /* 图片高度自动调整以保持比例 */
  object-fit: cover; /* 确保图片覆盖整个容器，同时保持比例 */
}
.wrapper {
  max-width: 1440px;
  margin: 0 auto;
}
.wrap1 {
  padding: 80px 0;
  background: #fff;
  // margin: 80px 0;
}
.wrap2 {
  // width: 90%;
  padding: 80px 112px 160px;
  .introduce {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .introduce-let {
      flex: 0 0 40%;
      // width: 22rem;
      // height: 22.6875rem;

      margin-right: 0.5rem;
      img {
        //    width: 485px;
        // height: 363px;
        // width: 10.1rem;
        // height: 7.56rem;
        width: 100%;
        height: 100%;
      }
    }
    .introduce-ret {
      flex: 0 0 60%;
      .introduce-ret-head {
        margin-bottom: 36px;
        .font_size_24 {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 6px;
        }
        .font_size_24_yin {
          font-size: 12px;
          // font-size: 0.3em;
        }
      }
      .introduce-ret-content {
        // width: 690px;
        font-family: Source Han Sans SC, Source Han Sans SC;
        font-weight: 500;
        font-size: 14px;
        color: #888888;
      }
    }
  }
}
.wrap3 {
  .wrap3-border {
    width: 100%;

    // background: #3474fa;
    .swiper {
      height: 393px;
      padding: 0 50px;
      .swiper-slide {
        position: relative;
        background: #ffffff;
        border-radius: 12px;
        .border-slide {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 64px 27px 0;
          // position: absolute;
          .border-slide-img {
            position: relative;
            width: 130px;
            height: 130px;
            display: flex;
            justify-content: center;
            img {
              max-width: 100%;
              height: 100%;
            }
          }
          .border-slide-bom {
            flex: 1;
            margin-top: 43px;
            // width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .titer {
              font-weight: 500;
              font-size: 14px;
              color: #888888;
              margin-bottom: 4px;
            }
            .number {
              font-size: 12px;
              color: #888888;
            }
            .heng {
              width: 100%;
              height: 2px;
              background: #e4e4e4;
              border-radius: 10px;
              margin: 8px 0;
            }
          }
        }
      }
    }
  }
  .wrap3-Genduo {
    margin: 30px auto 0;
    text-align: center;
    border-radius: 6px;
    border: 1px solid #000000;
    width: 144px;
    height: 39px;
    line-height: 39px;
    font-weight: 500;
    font-size: 16px;
    color: #222222;
    cursor: pointer;
  }
}
.wrap4 {
  margin: 160px 0 140px;
  .wrap4-border {
    padding: 50px 0;
    background: #fff;
    width: 100%;
    display: flex;
    border-radius: 20px;
    justify-content: space-evenly;
    align-items: center;
    .li-1 {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-weight: 500;
      font-size: 12px;
      color: #888888;
      img {
        width: 36px;
        height: 36px;
        margin-bottom: 10px;
      }
      div {
        margin-bottom: 4px;
      }
    }
    .li-2 {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      div {
        font-weight: 500;
        font-size: 16px;
        color: #888888;
      }
      .li-2-zhong {
        margin-bottom: 8px;
        font-size: 24px;
      }
    }
    .li-3 {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      div {
        font-weight: 500;
        font-size: 16px;
        color: #888888;
      }
      .li-3-zhong {
        margin-bottom: 8px;
        font-size: 24px;
      }
    }
    .heng {
      width: 2px;
      height: 56px;
      background: #e8e8e8;
      border-radius: 5px;
    }
  }
}

.solve {
  // margin-top: 80px;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.border {
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  // border-radius: 6px;
  // border: 1px solid #ebeef5;
  // margin: 10px;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.border_img_parent {
  // margin-top: 20px;
  display: flex;
  justify-content: center;
}

.product_mobile_content {
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.product_mobile_img {
  height: 550px;
  width: 100%;
}

.product_admin_img {
  height: 450px;
  width: 100%;
}

.product_mobile_title {
  font-weight: bold;
  text-align: center;
}

.product_pc_one {
  text-align: center;
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.font_size_30 {
  font-size: 1.875em;
}

.product_pc_img {
  height: 500px;
  width: 100%;
}

.product_pc {
  width: 90%;
  align-items: center;
  margin: 10px auto;
  background: #f2f6fc;
}

.border_title {
  font-family: "PingFang SC";
  margin-top: 16px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}

.border_content_one {
  width: 228px;
  margin-top: 8px;
  font-size: 12px;
  text-align: center;
  color: #888888;
}

.border_content_two {
  margin-top: 5px;
  font-size: 1.125em;
  margin-bottom: 25px;
  text-align: center;
}

.img_border {
  margin-top: 15px;
  width: 80px;
  height: 80px;
}

.cooperation {
  margin-top: 30px;
  width: 100%;
}

.product_mobile {
  width: 90%;
  align-items: center;
  margin: 10px auto;
  background: #f2f6fc;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 430px) {
  .el-carousel {
    // .el-carousel__item:nth-child(2n) {
    //   background-color: #99a9bf;
    // }
    // .el-carousel__item:nth-child(2n + 1) {
    //   background-color: #d3dce6;
    // }
    :deep(.el-carousel__indicators--outside) {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      bottom: 0%;
      left: 38%;
    }
  }
  .slider_img {
    width: 100%; /* 图片宽度适应容器 */
    height: auto; /* 图片高度自动调整以保持比例 */
    object-fit: cover; /* 确保图片覆盖整个容器，同时保持比例 */
  }

  .border_parent {
    display: flex;
    // width: 90%;
    margin: auto;
    height: auto;
    flex-direction: column;
  }

  .border {
    float: left;
    width: 100%;
    height: auto;
    margin: 10px 0 auto;
    /*background: aquamarine;*/
  }

  .border_img_parent {
    margin-top: 0;
  }

  .product_mobile {
    width: 90%;
    align-items: center;
    margin: 20px auto;
    height: auto;
    background: #f2f6fc;
  }

  .product_mobile_content {
    width: 100%;
    margin-top: 5px;
  }

  .product_mobile_img {
    float: left;
  }

  .product_mobile_title {
    font-weight: bold;
  }

  .product_pc_one {
    width: 100%;
    margin-top: 15px;
  }

  .font_size_30 {
    font-size: 1.25em;
  }

  .product_pc_img {
    height: 280px;
    width: 100%;
  }

  .product_pc {
    width: 90%;
    height: auto;
    margin: 20px auto;
    align-items: center;
    background: #f2f6fc;
  }

  .head-label {
    display: flex;
    // margin-top: 10px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .head-hen {
      width: 18px;
      height: 2px;
      background: linear-gradient(328deg, #3474fa 0%, #30e5fc 100%);
      border-radius: 31px 31px 31px 31px;
    }
    .font_size_24_yin {
      font-weight: 400;
      font-size: 1em;
      color: #888888;
    }
  }

  .border_title {
    font-family: "PingFang SC";
    margin-top: 16px;
    font-size: 0.8em;
    font-weight: bold;
  }

  .border_content_one {
    width: 162px;
    margin-top: 8px;
    font-size: 0.8em;
    color: #888888;
  }

  .border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 8px;
  }

  .img_border {
    // margin-top: 8px;
    width: 88px;
    height: 88px;
  }
  .wrap2 {
    padding: 80px 0 80px;
  }

  .introduce-h5 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .introduce-let-h5 {
      // margin-top: 40px;
      width: 100%;
      // margin-right: 24px;
      img {
        width: 100%;
      }
    }
    .introduce-ret-h5 {
      padding: 0 10px;
      .introduce-ret-content-h5 {
        // width: 690px;
        font-family: Source Han Sans SC, Source Han Sans SC;
        font-weight: 500;
        font-size: 14px;
        color: #888888;
      }
    }
  }

  .wrap3 {
    .wrap3-border {
      width: 100%;

      // background: #3474fa;
      .swiper {
        height: 300px;
        .swiper-slide {
          .border-slide {
            padding: 24px 6px 0;
            // .border-slide-img {
            //   width: 100px;
            //   height: 100px;
            //   img {
            //     max-width: 100%;
            //     height: 100%;
            //   }
            // }
          }
        }
      }
    }
  }
  .wrap4 {
    margin: 130px 0 110px;
    .wrap4-border {
      margin: 0 auto;
      width: 80%;
      justify-content: normal;
      flex-wrap: wrap;
      padding: 25px;
      .heng {
        display: none;
      }
      .li-1 {
        width: 48%;
      }
      .li-2 {
        width: 40%;
        align-items: flex-end;
        div {
          font-size: 9px;
        }
        .li-2-zhong {
          font-size: 16px;
        }
      }
      .li-3 {
        margin-left: 45px;
        width: 34%;
        // align-items: center;
        div {
          font-size: 9px;
        }
        .li-3-zhong {
          font-size: 16px;
        }
      }
    }
    .wrap4-border .li-1:first-child {
      border-bottom: 1px solid #d1d1d1;
      padding-bottom: 10px;
    }
    .wrap4-border .li-1:last-child {
      padding-top: 10px;
      border-top: 1px solid #d1d1d1;
      margin-top: -1px;
    }
  }
}

.font_size_24 {
  font-size: 18px;
}
.head-hen {
  width: 18px;
  height: 2px;
  background: linear-gradient(328deg, #3474fa 0%, #30e5fc 100%);
  border-radius: 31px 31px 31px 31px;
  margin: 6px 0;
}
.font_size_24_yin {
  font-weight: 400;
  font-size: 12px;
  color: #888888;
}
</style>
